<template>
  <div>
    <!--叶子级菜单-->
    <template v-if="!item.children || item.children.length === 0">
        <el-menu-item :key="item.href" :index="item.href">
          <i :class="item.icon?item.icon:'padding30'"></i>
          {{item.name}}
        </el-menu-item>
    </template>
    <!--父级菜单-->
    <el-submenu v-else :index="item.href" style="text-align: left;">
        <span slot="title">
            <i :class="item.icon?item.icon:'padding30'"></i>
            {{item.name}}
        </span>
        <template v-for="child in item.children" style="padding-left: 20px;">
            <navigation-item v-if="child.children && child.children.length>0" :key="child.href" :item="child"/>
            <el-menu-item v-else :index="child.href">
            <i :class="child.icon?child.icon:'padding30'"></i>
            {{child.name}}
            </el-menu-item>
        </template>
    </el-submenu>
  </div>
</template>
 
<script>
  export default {
    name: 'NavigationItem',
    props: {
      item: {
        type: Object,
        required: true
      }
    }
  }
</script>
<style lang="scss" scoped>
  .padding30{
    padding-left: 30px;
  }
  .padding50{
    padding-left: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu/navigation.vue